import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './alcance/guards/auth.guard';

const routes: Routes = [
    {
        path: '',
        loadChildren: () => import('./pages/pages.module').then(m => m.PagesPageModule),
        canActivate: [AuthGuard]
    },
    {
        path: 'hall',
        loadChildren: () => import('./pages/hall/hall.module').then(m => m.HallPageModule),
    },
    {
        path: 'app/:edificacao',
        loadChildren: () => import('./pages/hall/hall.module').then(m => m.HallPageModule),
    },
    {
        path: 'assinatura',
        loadChildren: () => import('./pages/assinatura/assinatura.module').then(m => m.AssinaturaPageModule),
    },
    {
        path: 'bloqueado',
        loadChildren: () => import('./pages/bloqueado/bloqueado.module').then(m => m.BloqueadoPageModule)
    },
    {
        path: 'quadro',
        loadChildren: () => import('./public/quadro/quadro.module').then(m => m.QuadroPageModule)
    },
    {
        path: 'inspecao',
        loadChildren: () => import('./public/atividade/atividade.module').then(m => m.AtividadePageModule)
    },
    {
        path: 'planta',
        loadChildren: () => import('./public/planta/planta.module').then(m => m.PlantaPageModule)
    },
    {
        path: 'documento-lote',
        loadChildren: () => import('./public/documento-lote/documento-lote.module').then(m => m.DocumentoLotePageModule)
    },
    {
        path: 'certificado-lote',
        loadChildren: () => import('./public/certificado-lote/certificado-lote.module').then( m => m.CertificadoLotePageModule)
    },
    {
        path: 'ata-presenca',
        loadChildren: () => import('./public/ata-presenca/ata-presenca.module').then(m => m.AtaPresencaPageModule)
    },
    {
        path: 'portal-auditoria',
        loadChildren: () => import('./public/portal-auditoria/portal-auditoria.module').then(m => m.PortalAuditoriaPageModule)
    },
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
    ],
    exports: [RouterModule]
})
export class AppRoutingModule { }
